import { BrowserRouter, Routes, Route } from "react-router-dom";
import MinimalLandingPage from "./pages/MinimalLandingPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MinimalLandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}
